import classNames from "classnames";
import "./button.scss";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonStyle?: "primary" | "danger" | "full" | "outline" | "goback" | "link";
}

export default function Button({ children, buttonStyle = "primary", ...rest }: ButtonProps) {
  return (
    <button className={classNames('button', buttonStyle)} {...rest}>
      {children}
    </button>
  );
}